/* import __COLOCATED_TEMPLATE__ from './site-wrapper.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './site-wrapper.module.scss';

@classic
@classNames('site-wrapper', styles.component)
export default class SiteWrapper extends Component {}
